import { useEffect, useState } from 'react';
import {
  isUpdateOverlayRegistered,
  showUpdateOverlayOutsideReact,
} from '@/services/updateOverlayService';
import { UpdateRequiredPanel } from './UpdateRequiredOverlay';

/**
 * In-page copy of the refresh prompt. The app root already mounts the
 * full-screen overlay, so this panel only shows when that overlay is not
 * registered.
 */
export function StaleChunkRecovery() {
  const [overlayRegistered] = useState(isUpdateOverlayRegistered);

  useEffect(() => {
    showUpdateOverlayOutsideReact();
  }, []);

  if (overlayRegistered) {
    return null;
  }

  return (
    <div className="flex min-h-[400px] w-full items-center justify-center p-4">
      <UpdateRequiredPanel />
    </div>
  );
}
